// extracted by mini-css-extract-plugin
module.exports = {"container":"_1MxohtLZdv9G1NwM8E-4zE","box":"_2wwJQUa9idgBr-PCOTZkRr shadow primaryBackgroundColor","balance":"_3vWz5FlbIrjUsXVFVI9Xbq"};